import { render, staticRenderFns } from "./BaseItemCompetitionPromoted.vue?vue&type=template&id=76e40be8&"
import script from "./BaseItemCompetitionPromoted.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetitionPromoted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports